export default __webpack_public_path__ + "static/media/arrow_forward.851d3cb7.svg";